import { z } from "zod/v4";

import { ScreenshotRecommendationSchema } from "../../../schemas/ai/ai-old";

export const ScreenshotRecommendationHistoryDtoSchema = z.object({
  id: z.uuid(),
  group: z.string(),
  dateTime: z.number(),
  screenshotUrl: z.string(),
  recommendations: ScreenshotRecommendationSchema.array(),
});

export type ScreenshotRecommendationHistoryDto = z.infer<
  typeof ScreenshotRecommendationHistoryDtoSchema
>;
